var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.18a9.08 9.08 0 0 0-.13-1.513H8.175v3.006h4.407c-.198.987-.777 1.82-1.635 2.387v2h2.63C15.113 12.667 16 10.613 16 8.18Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.174 16c2.207 0 4.053-.72 5.401-1.94l-2.63-2c-.735.48-1.668.773-2.771.773-2.132 0-3.937-1.406-4.584-3.306H.879v2.06C2.22 14.2 4.979 16 8.174 16Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59 9.527A4.553 4.553 0 0 1 3.33 8c0-.533.096-1.047.26-1.527v-2.06H.879A7.771 7.771 0 0 0 0 8c0 1.293.32 2.507.879 3.587l2.71-2.06Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.174 3.167c1.205 0 2.282.406 3.133 1.2l2.33-2.28C12.226.793 10.38 0 8.173 0 4.979 0 2.22 1.8.879 4.413l2.71 2.06c.648-1.9 2.453-3.306 4.585-3.306Z",
    fill: "#EA4335"
  })));
};
export default SvgGoogle;